import apiService from './api-service'

const monthlyCutsService = {}

/**
 * Retrieve a monthlyCuts by it's id
 * @param  array params (optional)
 * @return monthlyCuts
 */
monthlyCutsService.list = function (params) {
  return apiService.get(`/monthly+cut`, { params }).then(res => res.data)
}

/**
 * Retrieve a monthlyCuts by it's id
 * @param  int id
 * @param  array params (optional)
 * @return monthlyCuts
 */
monthlyCutsService.getById = function (id, params) {
  return apiService.get(`/monthly+cut/${id}`, { params }).then(res => res.data)
}

/**
 * Update a monthlyCuts by it's id
 * @param  int id
 * @param  array params (optional)
 * @return monthlyCuts
 */
monthlyCutsService.updateById = function (id) {
  return apiService.put(`/monthly+cut/${id}`).then(res => res.data)
}

/**
 * Create a monthlyCuts by it's id
 * @param  objet body
 * @return monthlyCuts
 */
monthlyCutsService.post = function (body) {
  return apiService.post(`/monthly+cut`, body).then(res => res.data)
}

/**
 * Generate Statements
 * @param  objet body
 * @return monthlyCut
 */
monthlyCutsService.generateStatements = function (id, body) {
  return apiService.post(`/monthly+cut/${id}/generateStatements`, body).then(res => res.data)
}

/**
 * Send Statements
 * @param  objet body
 * @return monthlyCut
 */
monthlyCutsService.sendStatements = function (id, body) {
  return apiService.post(`/monthly+cut/${id}/sendStatements`, body).then(res => res.data)
}

/**
 * Complete monthlyCuts
 * @param  objet body
 * @return monthlyCut
 */
monthlyCutsService.complete = function (id) {
  return apiService.post(`/monthly+cut/${id}/complete`).then(res => res.data)
}

/**
 * Get Mailing Log records
 * @param  objet body
 * @return monthlyCut
 */
monthlyCutsService.getLogs = function (id) {
  return apiService.get(`/monthly+cut/${id}/getMailingLog`).then(res => res.data)
}

/**
 * Get Investors records
 * @param  objet body
 * @return monthlyCut
 */
monthlyCutsService.getInvestors = function (id) {
  return apiService.get(`/monthly+cut/${id}/investors`).then(res => res.data)
}

/**
 * Get Attachments records
 * @param  objet body
 * @return monthlyCut
 */
monthlyCutsService.getAttachments = function (id) {
  return apiService.get(`/monthly+cut/${id}/attachments`).then(res => res.data)
}

/**
 * Get Payments records
 * @param  objet body
 * @return monthlyCut
 */
monthlyCutsService.getPayments = function (id) {
  return apiService.get(`/monthly+cut/${id}/payments`).then(res => res.data)
}

/**
 * Get Dispersion Txt File
 * @param  objet body
 * @return monthlyCut
 */
monthlyCutsService.getDispersion = function (id) {
  return apiService.get(`/monthly+cut/${id}/getDispersion`).then(res => res.data)
}

/**
 * Get Dispersion Txt File
 * @param  objet body
 * @return monthlyCut
 */
monthlyCutsService.getDispersionInter = function (id) {
  return apiService.get(`/monthly+cut/${id}/getDispersionInter`).then(res => res.data)
}

/**
 * Get Mailing Log records
 * @param  objet body
 * @return monthlyCut
 */
monthlyCutsService.getLogs = function (id) {
  return apiService.get(`/monthly+cut/${id}/getMailingLog`).then(res => res.data)
}

monthlyCutsService.getMonthlyCutReport = function (id) {
  return apiService.get(`/report-monthlyCut/${id}`).then(res => res.data)
}

monthlyCutsService.getStatement = function (id) {
  return apiService.get(`/statement-monthlyCut/${id}`).then(res => res.data)
}

export default monthlyCutsService



// WEBPACK FOOTER //
// ./src/services/monthly_cuts.js